<template>

	<div :class="{results:true,'has-report':hasReport}">

		<div class="result-heading-wrap" v-if="hasReport">

			<h2 :class="{ 'result-heading': true, yes: this.settings.report.title }">Title Tag</h2>

			<h2 :class="{ 'result-heading': true, yes: this.settings.report.description }">Meta Description</h2>

		</div>

		<div class="result-heading-wrap" v-if="hasReport">

			<h2 :class="{ 'result-heading': true, yes: this.settings.report.headerTags>0 }">Header Tags</h2>

			<h2 :class="{ 'result-heading': true, yes: this.settings.report.content>0 }">Content<span v-if="this.settings.report.content>0" v-html="' ('+( this.settings.report.content > 1 ? ( this.settings.report.content + ' times' ) : 'once' )+')'" /></h2>

		</div>

		<div class="button-wrap">

			<TableButton :settings="buttonSettings" class="theButton" @clicked="clicked" />

		</div>

	</div>

</template>

<script>
import TableButton from './TableButton.vue'
export default {
  name: 'TableDataDiveReport',
  props: ['settings'],
  components: {
	TableButton
  },
  data() {
  return {
    
  }
  },
  computed: {

	hasReport () {

		return !!this.settings.report;

	},

    classes () {

      let c = this.settings.classes !== 'undefined' ? this.settings.classes : {};

      c.click = this.click;

      return c;

    },
	click () {
		return this.hasReport || ( this.settings.click !== 'undefined' && this.settings.click === true );
	},
	buttonSettings () {

		return {
			classes: { 
				green: true, 
				default: false 
			},
			label: this.hasReport ? 'View/Hide Report' : this.settings.label || 'Run Report',
			hasReport: this.hasReport,
			click: this.click,
			href: this.settings.href
		}

	}

  },
  methods: {
  
    clicked() {

        this.$emit('clicked',null);

    }

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
.results {

	text-align: left;
	position: relative;

	.result-heading-wrap {

		text-align: left;

		&:first-child {

			padding-top: 4px;

		}

	}

	.button-wrap {
		
		text-align: left;

	}

	&.has-report {

		.button-wrap {

			opacity: 0;
			width: 100%;
			height: 100%;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			z-index: 1;
			position: absolute;

		}

	}

	.result-heading {

		position: relative;
		padding: 0 0 0 1.25em;
		font-size: 12px;
		display: inline-block;
		margin: 0 8px 0 0;
		z-index: 2;

		&:before {
			content: "❌";
			position: absolute;
			display: block;
			font-size: 0.65em;
			left: 0;
			top: 4px;
		}

		&.yes {

			&:before {

				content: "✔";
				color: #37b74a;
				font-size: 1em;
				top: 0;

			}

		}

	}

	&:hover {

		.button-wrap {

			opacity: 1;
			z-index: 2;

		}

		.result-heading-wrap {

			opacity:0;
			z-index: 1;

		}

	}

}
@media screen and (min-width: 1024px) {

 

}
</style>